import { FieldViewModel } from "../../fields"

export class TargetField {

    public disabled: boolean

    constructor(public readonly field: FieldViewModel) {
        this.disabled = field.disabled
    }

    get fieldId() {
        return this.field.fieldId
    }

    get fieldName() {
        return this.field.fieldName
    }

    get description() {
        return this.field.description
    }
}
